import config from 'src/utils/config';

import ValueNode from '../ValueNode';
import Type from '../../Type';

import type Context from 'src/Context';
import type { BaseExpression, Expression, UiConfig } from 'src/types';

export interface EvaluationNodeT extends BaseExpression {
    $type: 'EvaluationNode';
    value: string;
}

export default class EvaluationNode extends ValueNode<EvaluationNodeT> {
    static TYPE = Type.Evaluation({
        key: 'value',
    });

    static uiConfig: UiConfig = { ...config.presets.primitive };

    validate(): string | null | undefined {
        if (typeof this.expression.value !== 'string' && this.expression.value !== null)
            return 'value must be a string or null';
    }

    static getDefault(): Expression {
        return {
            ...super.getDefault(),
            value: '',
        };
    }

    async execute(context: Context): Promise<any> {
        if (!this.expression.value) return null;
        return context.evaluate(`{${this.expression.value}}`);
    }
}
